import { Stack, Box, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';

export default function LeftFloatView(props) {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    function subscribeTap() {
        dispatch(settingActions.showRegisterAlert(true));
    }

    return (
        <Stack
            id={'home_page_left_view'}
            sx={{
                position: 'fixed',
                zIndex: 2,
                left: settingData.isMobile ? 10 : 30,
                top: settingData.isMobile ? 100 : 150,
                alignItems: 'center',
            }}>
            <Stack sx={{
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center'
            }}>
                <Box
                    component={'img'}
                    src={JSTool.getImgPath('game_icon.png')}
                    sx={{
                        height: '100rem',
                        width: '100rem',
                        borderRadius: '20rem',
                        mb:1,
                        boxShadow: '0 5px 25px #71C3D8'
                    }} />

                <Box
                    onClick={() => { JSTool.appleTap() }}
                    component={'img'}
                    src={JSTool.getImgPath('release_apple.png')}
                    sx={{
                        height: '45rem',
                        filter: 'drop-shadow(0px 0px 15px #2BBFD5)',
                        transitionDuration: '0.3s',
                        cursor: 'pointer',
                        '&:hover': {
                            transform: 'scale(1.05)',
                        }
                    }} />

                <Box
                    onClick={() => { JSTool.googleTap() }}
                    component={'img'}
                    src={JSTool.getImgPath('release_google.png')}
                    sx={{
                        mt:1,
                        height: '45rem',
                        filter: 'drop-shadow(0px 0px 15px #2BBFD5)',
                        transitionDuration: '0.3s',
                        cursor: 'pointer',
                        '&:hover': {
                            transform: 'scale(1.05)',
                        }
                    }} />
            </Stack>

            <Typography
                onClick={subscribeTap}
                sx={{
                    zIndex: 2,
                    mt:-1,
                    ml: '3px',
                    width: '170rem',
                    height: '70rem',
                    lineHeight: '70rem',
                    backgroundSize: '100% 100%',
                    color: 'white',
                    fontSize: '17rem',
                    textAlign: 'center',
                    backgroundImage: `url(${JSTool.getImgPath('time_bg2.png')})`,
                    fontWeight: 'bold',
                    fontFamily: window.font0,
                    opacity: 0.9,
                    cursor: 'pointer',
                    transitionDuration: '0.3s',
                    '&:hover': {
                        transform: 'scale(1.05)',
                    },
                }}>
                SUBSCRIBE
            </Typography>
        </Stack>
    );
}